import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();
const getLocalTZ = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (_) {
    return "UTC";
  }
};

export const getDashboardSummaryAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/summary", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getDashboardEarningsTrendAPI = ({ month, year }) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/earnings-daily", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: {
          month,
          year,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const getDashboardEarningsOverviewAPI = ({ month, year }) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/earnings-overview", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: {
          month,
          year,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getDashboardRevenueAPI = (year) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/revenue", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: {
          year,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getTopTippersAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/top-tippers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getTopSubscribersAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/top-subscribers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getTopCustomVideoBuyersAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/top-custom-video-buyers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getTopPostBuyersAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/top-post-buyers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/analytics/summary
export const getAdminSummaryAPI = ({
  from,
  to,
  month,
  year,
  creatorId,
  by,
} = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/summary", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { from, to, month, year, creatorId, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/analytics/revenue
export const getAdminRevenueAPI = ({ year, creatorId, by } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/revenue", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { year, creatorId, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/analytics/top-creators
export const getAdminTopCreatorsAPI = ({ from, to, limit = 10, by } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/top-creators", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { from, to, limit, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/analytics/top-spenders
export const getAdminTopSpendersAPI = ({
  from,
  to,
  limit = 10,
  creatorId,
  by,
} = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/top-spenders", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { from, to, limit, creatorId, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
// /api/admin/overview  -> прокситься як /api/dashboard/admin/overview
export const getAdminOverviewAPI = ({
  from,
  to,
  month,
  year,
  onlineWindow = "5m",
  by,
} = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/overview", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { from, to, month, year, onlineWindow, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
// /api/admin/revenue-trend
export const getAdminRevenueTrendAPI = ({
  from,
  to,
  creatorId,
  by,
  granularity = "daily", // "daily" | "weekly" | "monthly" — як групувати
  preset, // "day" | "week" | "month" — який період брати
  tz = getLocalTZ(),
  fillGaps = true,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/revenue-trend", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      // якщо передаєш preset — бек ігнорує from/to та сам виставляє межі (сьогодні / тиждень / місяць)
      params: { from, to, creatorId, by, granularity, preset, tz, fillGaps },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// /api/admin/signups-trend
export const getAdminSignupsTrendAPI = ({
  from,
  to,
  granularity = "daily", // "daily" | "weekly" | "monthly"
  preset, // "day" | "week" | "month"
  tz = getLocalTZ(),
  fillGaps = true,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/signups-trend", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { from, to, granularity, preset, tz, fillGaps },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// /api/admin/conversion
export const getAdminConversionAPI = ({
  from,
  to,
  granularity = "daily",
} = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/conversion", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { from, to, granularity },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/retention
export const getAdminRetentionAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/retention", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/monetization
export const getAdminMonetizationAPI = ({ from, to, creatorId, by } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/monetization", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { from, to, creatorId, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
// ---- Payouts overview ----
export const getAdminPayoutsOverviewAPI = ({
  from,
  to,
  creatorId,
  by,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/payouts-overview", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { from, to, creatorId, by },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// ---- Average earnings per creator ----
export const getAdminAvgEarningsAPI = ({ from, to, creatorId, by } = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/avg-earnings", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { from, to, creatorId, by },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// /api/admin/creator-activity
// export const getAdminCreatorActivityAPI = ({ from, to } = {}) => {
//     return new Promise((resolve, reject) => {
//         const tokens = getTokens();
//         axiosInstance
//             .get("/api/dashboard/admin/creator-activity", {
//                 headers: {
//                     "Content-Type": "application/json",
//                     [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
//                     [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
//                     "ngrok-skip-browser-warning": "true",
//                 },
//                 params: { from, to },
//             })
//             .then((res) => resolve(res.data))
//             .catch((err) => reject(err?.response?.data || err));
//     });
// };
// --- Creator Activity ---
// 1) Active creators today
export const getAdminActiveCreatorsTodayAPI = ({
  tz,
  since,
  preset = "day",
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/creator-activity/active-today", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      // якщо передаєш since (напр. "15m"), бек використає його; інакше preset=day
      params: { tz, since, preset },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// 2) Content upload volume (photos/videos)
export const getAdminUploadVolumeAPI = ({
  from,
  to,
  granularity = "daily", // "daily" | "weekly" | "monthly"
  preset, // "day" | "week" | "month"
  tz = getLocalTZ(),
  fillGaps = true,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/creator-activity/uploads", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { from, to, granularity, preset, tz, fillGaps },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// Quick actions
export const approveCreatorAPI = (userId) => {
  const tokens = getTokens();
  return axiosInstance.post(
    `/api/dashboard/admin/creators/${userId}/approve`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
};

export const banUserAPI = (userId, reason) => {
  const tokens = getTokens();
  return axiosInstance.post(
    `/api/dashboard/admin/users/${userId}/ban`,
    { reason },
    {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
};

export const sendWarningAPI = (userId, message) => {
  const tokens = getTokens();
  return axiosInstance.post(
    `/api/dashboard/admin/users/${userId}/warn`,
    { message },
    {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
};
// /api/admin/transactions
export const getAdminTransactionsAPI = ({ creatorId, by } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/transactions", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { creatorId, by },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
// /api/admin/compliance
export const getAdminComplianceAPI = ({ days = 30 } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/compliance", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { days },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
// /api/admin/security/sessions-now
export const getAdminSessionsNowAPI = ({ since = "5m" } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/security/sessions-now", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { since },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// /api/admin/security/failed-logins
// export const getAdminFailedLoginsAPI = ({ from, to, limit = 200 } = {}) => {
//     return new Promise((resolve, reject) => {
//         const tokens = getTokens();
//         axiosInstance
//             .get("/api/dashboard/admin/security/failed-logins", {
//                 headers: {
//                     "Content-Type": "application/json",
//                     [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
//                     [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
//                     "ngrok-skip-browser-warning": "true",
//                 },
//                 params: { from, to, limit },
//             })
//             .then(res => resolve(res.data))
//             .catch(err => reject(err?.response?.data || err));
//     });
// };

// /api/admin/security/visitor-ips
export const getAdminVisitorIPsAPI = ({ since = "24h", limit = 200 } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/security/visitors", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { since, limit },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
// GET /api/dashboard/admin/security/ips-by-user?userId=...&limit=100
export const getAdminIPsByUserAPI = ({ userId, limit = 100 } = {}) => {
  if (!userId) {
    return Promise.reject({ message: "userId is required" });
  }
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/admin/security/ips-by-user", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { userId, limit },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getAdminUsersLastIPsAPI = ({
  since = "30d",
  limit = 500,
  search = "",
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/admin/security/users-last-ips", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { since, limit, ...(search ? { search } : {}) },
    })
    .then((r) => r.data);
};

// self-service (користувач дивиться свої логи)
export const getMySessionsAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/security/me/sessions", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const getMyFailedLoginsAPI = ({ days = 30 } = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/dashboard/security/me/failed-logins", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { days },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// POST /api/dashboard/security/me/visitor-snapshot
// Зберігає останній Visitor API snapshot для поточного авторизованого користувача.
export const saveMyVisitorSnapshotAPI = ({ visitor, ipAddress } = {}) => {
  const tokens = getTokens();
  const headers = {
    "Content-Type": "application/json",
    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
    "ngrok-skip-browser-warning": "true",
  };

  // Firebase token is deprecated and should not override auth header.
  if (
    tokens.firebase_token &&
    process.env.REACT_APP_FIREBASE_AUTH_TOKEN &&
    process.env.REACT_APP_FIREBASE_AUTH_TOKEN !== process.env.REACT_APP_AUTH_TOKEN
  ) {
    headers[process.env.REACT_APP_FIREBASE_AUTH_TOKEN] =
      `Bearer ${tokens.firebase_token}`;
  }

  return axiosInstance
    .post(
      "/api/dashboard/security/me/visitor-snapshot",
      {
        visitor,
        ...(ipAddress ? { ipAddress } : {}),
      },
      {
        headers,
      },
    )
    .then((res) => res.data);
};

// Creator revenue trend API (for daily/weekly charts)
export const getCreatorRevenueTrendAPI = ({
  granularity = "daily", // "daily" | "weekly"
  preset, // "day" | "week"
  tz = getLocalTZ(),
  fillGaps = true,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/revenue-trend", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { granularity, preset, tz, fillGaps },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// Creator upload volume API (for daily/weekly/monthly charts)
export const getCreatorUploadVolumeAPI = ({
  granularity = "daily", // "daily" | "weekly" | "monthly"
  preset, // "day" | "week" | "month"
  tz = getLocalTZ(),
  fillGaps = true,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/upload-volume", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { granularity, preset, tz, fillGaps },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};

// Creator transaction volume API (for 24h/7d charts)
export const getCreatorTransactionVolumeAPI = ({
  period = "24h", // "24h" | "7d"
  granularity = "hourly", // "hourly" | "daily"
  tz = getLocalTZ(),
  fillGaps = true,
} = {}) => {
  const tokens = getTokens();
  return axiosInstance
    .get("/api/dashboard/transaction-volume", {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
      params: { period, granularity, tz, fillGaps },
    })
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data || err));
};
